import { render, staticRenderFns } from "./teacherCourse.vue?vue&type=template&id=7a3236a6&"
import script from "./teacherCourse.vue?vue&type=script&lang=js&"
export * from "./teacherCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports